/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingConsentDto } from '../../models/marketing-consent-dto';

export interface MarketingConsentControllerFindAllV1$Params {
}

export function marketingConsentControllerFindAllV1(http: HttpClient, rootUrl: string, params?: MarketingConsentControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MarketingConsentDto>>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MarketingConsentDto>>;
    })
  );
}

marketingConsentControllerFindAllV1.PATH = '/api/v1/marketing-consent';
